import block from "bem-css-modules";
import {Sessions} from "./Sessions";
import s from './Day.module.scss';
import classNames from "classnames";
import {format, parseISO} from 'date-fns';

const b = block(s);
export const Day = ({day, sessions}) => {
    const formattedDay = format(parseISO(day), 'EEEE, MMMM d, yyyy');
    return (<>
        <div className={classNames(b('header'), 'row')}>
            <div className={classNames('col-md-3 col-12', b('date'))}>{formattedDay}</div>
            <div className={classNames('row', 'col-md-9', 'd-none', 'd-md-flex')}>
                <div className={classNames('col-md-6', b('title'))}>Title</div>
                <div className={classNames('col-md-2', b('location'))}>Location</div>
                <div className={'col-md-4'}>Speakers</div>
            </div>
        </div>
        <Sessions sessions={sessions}/>
    </>)
}
